<template>
	<div class="activity page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
	</div>
</template>

<script>
	export default {
		name: 'activity',
		data() {
			return {
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加活动',
					sign: 'new'
				}],
				filterValue: {
					keyword: '',
					criteria: '',
					date: '',
					daterange: ''
				},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					activityMenu: true,
					tableHeader: [{
						prop: 'activityName',
						label: '活动名称',
						width: 400
					}, {
						prop: 'activityDescribe',
						label: '活动描述',
						width: 500
					}, {
						prop: 'activityStatus',
						label: '活动状态',
						width: 150,
						template: true
					}],
					tableEvent: [{
							icon: 'el-icon-edit',
							name: '编辑',
							color: 'blue',
							sign: 'edit'
						},
						{
							icon: 'el-icon-video-play',
							name: '开启活动',
							color: 'green',
							sign: 'start'
						},
						{
							icon: 'el-icon-video-pause',
							name: '停止活动',
							color: 'red',
							sign: 'stop'
						},
						{
							icon: 'el-icon-delete',
							name: '删除',
							color: 'red',
							sign: 'delete'
						}
					],
					emptyDescription: '当前没有数据',
				},
				tableData: []
			};
		},
		methods: {
			// 页面变化
			pageChange() {
				this.fetchData()
			},
			// 右上按钮
			buttonClick(sign) {
				if (sign === 'new') {
					this.$router.push({
						path: '/activityedit',
						query: {
							id: ''
						}
					})
				}

			},
			// 筛选条件变化
			filterChange() {
				console.log(this.filterValue);
			},
			// 操作按钮
			scopeButtonClick(row, sign) {
				console.log(row, sign)
				if (sign == 'edit') {
					this.$router.push({
						path: '/activityedit',
						query: {
							id: row.id
						}
					})
				}

				if (sign === 'start') {
					if (row.activityStatus == 1) {
						this.$message({
							type: 'warning',
							message: '当前活动已开启',
							duration: 2000
						})
						return
					}
					this.$api.activityOpen({
						id: row.id
					}, res => {
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								type: 'success',
								message: '当前活动开启成功',
								duration: 2000
							})
						}
					})
				}
				if (sign === 'stop') {
					if (row.activityStatus != 1) {
						this.$message({
							type: 'warning',
							message: '当前活动已停止',
							duration: 2000
						})
						return
					}
					this.$api.activityClose({
						id: row.id
					}, res => {
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								type: 'success',
								message: '当前活动停止成功',
								duration: 2000
							})
						}
					})
				}
				if (sign === 'delete') {
					this.deleteActivity(row)
				}
			},
			fetchData() {
				this.$api.activityList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						this.tableData = res.data.list
					}
				})
			},
			deleteActivity(row) {
				this.$confirm('确认要删除这个活动吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.activityDelete({
						id: row.id
					}, res => {
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: '删除成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}).catch(() => {});
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped"></style>
